export interface Permissions {
  /**
   * Whether the user can view pricing.
   */
  viewJobPricing: boolean

  /**
   * Whether the user can start a new job.
   */
  startNewJob: boolean
}

export const Permissions = {
  /**
   * Returns an empty permission set.
   */
  empty: (): Permissions => ({
    viewJobPricing: true,
    startNewJob: true,
  }),
}
